import { Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SessionService } from '../../../../../auth/session.service';
import ProjectLinks from '../../../../../common/project.links';
import { OrganizationLink } from '../../../../../swagger-api';
import { OrganizationLinkUrlParams } from './organization-link.interfaces';

@Component({
  selector: 'app-view-profile-organization-links',
  templateUrl: './organization-link-view.component.html',
  styleUrls: ['./organization-link-view.component.scss'],
})
export class OrganizationLinkViewComponent implements OnChanges {
  public organizationLinkUrlParams: OrganizationLinkUrlParams[];

  @Input({ required: true }) public organizationLink: OrganizationLink[];

  @Input({ required: false }) public fieldNumber = 0;
  @Input({ required: false }) public dataTestId = '';
  @Input({ required: false }) public shouldRedirectWhenNoSession = false;

  private sessionService = inject(SessionService);

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['organizationLink'].currentValue) {
      this.organizationLinkUrlParams = this.prepareOrganizationLinks(
        changes['organizationLink'].currentValue as OrganizationLink[],
      );
    }
  }

  public isCustomOrganization(organization: OrganizationLink): boolean {
    return organization.organization_link_kind === OrganizationLink.OrganizationLinkKindEnum.CUSTOM;
  }

  public prepareRouterUrlParams(organizationLink: OrganizationLink): OrganizationLinkUrlParams {
    if (this.isCustomOrganization(organizationLink)) {
      return {
        isCustom: true,
        organization_name: organizationLink.organization_name,
      };
    } else if (this.sessionService.isSessionActive() && this.shouldRedirectWhenNoSession) {
      return {
        organization_name: organizationLink.organization_name,
        url: `${ProjectLinks.LINK_PROFILE_VIEW}/${organizationLink.organization_user_id}`,
      };
    } else {
      return {
        organization_name: organizationLink.organization_name,
        url: ProjectLinks.LINK_LOGIN,
        params: { returnUrl: `${ProjectLinks.LINK_PROFILE_VIEW}/${organizationLink.organization_user_id}` },
      };
    }
  }

  private prepareOrganizationLinks(organizationLinks: OrganizationLink[]): OrganizationLinkUrlParams[] {
    return organizationLinks.map((organizationLink: OrganizationLink) => {
      return this.prepareRouterUrlParams(organizationLink);
    });
  }
}
